import {Auth,API} from "aws-amplify";
import React, { useEffect, useState } from "react";
import {getPlayslide, listHosts, listPlayslides} from "../../graphql/queries";
import {useHistory, useParams} from "react-router-dom";
import {newUpdatePlayslide,newDeletePlayslide} from "../../graphql/subscriptions";
import {updatePlayslide} from "../../graphql/mutations";
import {Modal} from 'react-bootstrap';
import {Form} from "element-react";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import Grid from '@material-ui/core/Grid';
import DeleteIcon from '../../img/delete.png';
import Navbars from "../../components/Navbarconvoze";
import Foot from "../../components/Foot";
import "./../css/editroom.css";
import {v4 as uuid} from "uuid";
import Leftarrow from "../../img/left-arrow.png";
import Noi from "../../img/no.png";
import {Helmet} from "react-helmet";
import Editb from "../../img/dash/edit.png";
import Allmove from "../../img/Move.svg";
import Zoomin from "../../img/zoom-in.png";
import Zoomout from "../../img/zoom-out.png";
import ListGroup from "react-bootstrap/ListGroup";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import Editbs from "../../pages/dashboard/icons/Edit.svg";
import Info from "../../img/dash/pop-up-icon.svg";
import Slide from "../../img/menu/text-slide.svg";
import Image from "../../img/menu/image.svg";
import Video from "../../img/menu/video.svg";
import Powerponit from "../../img/menu/powerpoint.svg";
import Pdf from "../../img/menu/pdf.svg";
import Gif from "../../img/menu/gif.svg";
import Link from "../../img/menu/show-webpage.svg";
import Videolink from "../../img/menu/video-link.svg";
import Draw from "../../img/menu/draw.svg";
import Record from "../../img/menu/record-a-video.svg";
import Giphy from "../../img/menu/giphy-library.svg";
import Polls from "../../img/menu/polls.svg";
import Open from "../../img/menu/eazyask-icon.svg";
import Single from "../../img/menu/single-select.svg";
import Multi from "../../img/menu/multi-select.svg";
import Fill from "../../img/menu/fill-in-the-blank.svg";
import Drawquiz from "../../img/menu/draw-quiz.svg";
import Videoquiz from "../../img/menu/video-quiz.svg";
import Math from "../../img/menu/math/math-single-select.svg";
import Memory from "../../img/menu/memory-matching-game.svg";
import Drag from "../../img/menu/tap-tap.svg";
import Textslidedis from "../../img/menu/dis/1-text-slide.png";
import Imagedis from "../../img/menu/dis/2-image.png";
import Videodis from "../../img/menu/dis/3-video.png";
import Pptxdis from "../../img/menu/dis/4-pptx.png";
import Pdfdis from "../../img/menu/dis/5-pdf.png";
import Gifdis from "../../img/menu/dis/6-gif.png";
import Linktodis from "../../img/menu/dis/7-link-to-webpage.png";
import Videolinkdis from "../../img/menu/dis/8-video-link.png";
import Drawdis from "../../img/menu/dis/9-draw.png";
import Recordvideo1dis from "../../img/menu/dis/10-1-record-video.png";
import Recordvideo2dis from "../../img/menu/dis/10-2-record-video.png";
import Giphydis from "../../img/menu/dis/gif.gif";
import Pollsdis from "../../img/menu/dis/Polls.gif";
import Openended1dis from "../../img/menu/dis/eazy-ask-response-submission.gif";
import Openended2dis from "../../img/menu/dis/eazyask-highlight-a-response.gif";
import Openended3dis from "../../img/menu/dis/eazyask-viewer-experience.gif";
import Singleselectdis from "../../img/menu/dis/Single-Select.gif";
import Multiselectdis from "../../img/menu/dis/Multi-Select.gif";
import Fillindis from "../../img/menu/dis/Fill-in-the-Blank.gif";
import Drawquizedis from "../../img/menu/dis/Draw-Quiz.gif";
import Videoquiz1dis from "../../img/menu/dis/Video-Quiz.gif";
import Mathquizedis from "../../img/menu/dis/Math-Quiz.gif";
import Mmgdis from "../../img/menu/dis/Memory-Matching-Game.gif";
import Taptapdis from "../../img/menu/dis/Tap-Tap.gif";
import Sequecing from "../../img/menu/sequencing.svg";
import Sequencingdis from "../../img/menu/dis/sequrncing.gif";
import Rankingmenu from "../../img/menu/ranking-poll.svg";
import Rankingpoll from "../../img/menu/dis/Ranking-Poll.gif";
import Adobeoverview from "../../img/menu/dis/overview-express.jpg";
import Adobeexpress from "../../img/menu/adobe-express.svg";
import Mathfill from "../../img/menu/math/math-fill-in-the-blank.svg";
import Mathmul from "../../img/menu/math/math-multi-select.svg";
import Mathseq from "../../img/menu/math/math-sequencing.svg";
import Mathslideicon from "../../img/menu/math-slide-icon.svg";
import Qrcodes from "../../img/host/explain/qrcode.png";
import "./../css/contenttypes.css";
import {
    DndContext,
    closestCenter,
    KeyboardSensor,
    PointerSensor,
    useSensor,
    useSensors,
    DragOverlay
} from '@dnd-kit/core';
import {
    arrayMove,
    SortableContext,
    sortableKeyboardCoordinates,
    horizontalListSortingStrategy,
} from '@dnd-kit/sortable';

import { SortableItem } from '../SortableItem';
import Flashcardsicon from "../../img/menu/flashcards-icon.svg";
import Flashcardsgif from "../../img/menu/dis/flashcards.gif";
import Mathslidegif from "../../img/menu/dis/math-slide.gif";
import Mathfillgif from "../../img/menu/dis/math-fill-in-the-blank.gif";
import Mathmultigif from "../../img/menu/dis/math-multi-select.gif";
import Mathsequgif from "../../img/menu/dis/math-sequencing.gif";
import Inviteform1 from "../invitepeople/inviteform1";
import Maxs from "../../img/host/explain/max.png";
import Slidelist from "../../img/host/explain/slidelist.png";
import Timer from "../../img/host/explain/timer.png";
import Whiteboards from "../../img/host/explain/whiteboard.png";
import Maths from "../../img/host/explain/math.png";
import Plays from "../../img/host/explain/play.png";
import Backs from "../../img/host/explain/left.png";
import Nexts from "../../img/host/explain/next.png";
import Syns from "../../img/host/explain/syn.png";
import Wordcloud from "../../img/menu/word-cloud-icon.svg";
import Wordcloudoverview from "../../img/menu/dis/word-cloud_640x360.jpg";

function Ceditroom() {
    const { id } = useParams();
    const history = useHistory();
    const [isUser, setIsUser] = useState(false);
    const [isUsere, setIsUsere] = useState(false);
    const [isOwner, setIsOwner] = useState(false);
    const [purls, setPurls] = useState([]);
    const [playcontents, setPlaycontents] = useState([]);
    const [ymeeting, setYmeeting] = useState("");
    const [icopied, setCiopied] = useState("");
    const [ymeetingid, setYmeetingid] = useState();
    const [duplicateopen, setDuplicateopen] = useState(true);
    const [indexs, setIndexs] = useState(false);
    const [titless, setTitless] = useState(false);
    const [show1, setShow1] = useState(false);
    const handleClose1 = () => {setShow1(false)};
    const [show2, setShow2] = useState(false);
    const [condata, setCondata] = useState([]);
    const [eurls, setEurls] = useState("");
    const [changesavedmessage, setChangesavedmessage] = useState("");
    const [show, setShow] = useState(false);
    const [isopen, setIsopen] = useState(true);
    const [isthislink, setIsthislink] = useState("full")
    const [isthisplan, setIsthisplan] = useState(true);
    const handleClose2 = () => setShow2(false);
    const handleClose = () => setShow(false);
    const [show3, setShow3] = useState(false);
    const handleClose3 = () => {setShow3(false);};
    const [openipinfomation, setOpenipinfomation] = useState(true);
    const [openipcalenders, setOpenipcalenders] = useState(false);
    const [openipexplainer, setOpenipexplainer] =useState(false);
    const d = uuid();
    const [show31, setShow31] = useState(false);
    const handleClose31 = () => {setShow31(false);setShow1(true)};
    const [show32, setShow32] = useState(false);
    const handleClose32 = () => {setShow32(false);setShow1(true)};
    const [show33, setShow33] = useState(false);
    const handleClose33 = () => {setShow33(false);setShow1(true)};
    const [show34, setShow34] = useState(false);
    const handleClose34 = () => {setShow34(false);setShow1(true)};
    const [show35, setShow35] = useState(false);
    const handleClose35 = () => {setShow35(false);setShow1(true)};
    const [show36, setShow36] = useState(false);
    const handleClose36 = () => {setShow36(false);setShow1(true)};
    const [show37, setShow37] = useState(false);
    const handleClose37 = () => {setShow37(false);setShow1(true)};
    const [show38, setShow38] = useState(false);
    const handleClose38 = () => {setShow38(false);setShow1(true)};
    const [show39, setShow39] = useState(false);
    const handleClose39 = () => {setShow39(false);setShow1(true)};
    const [show40, setShow40] = useState(false);
    const handleClose40 = () => {setShow40(false);setShow1(true)};
    const [show10, setShow10] = useState(false);
    const handleClose10 = () => {setShow10(false);setShow1(true)};
    const [show11, setShow11] = useState(false);
    const handleClose11 = () => {setShow11(false);setShow1(true)};
    const [show12, setShow12] = useState(false);
    const handleClose12 = () => {setShow12(false);setShow1(true)};
    const [show13, setShow13] = useState(false);
    const handleClose13 = () => {setShow13(false);setShow1(true)};
    const [show14, setShow14] = useState(false);
    const handleClose14 = () => {setShow14(false);setShow1(true)};
    const [show15, setShow15] = useState(false);
    const handleClose15 = () => {setShow15(false);setShow1(true)};
    const [show16, setShow16] = useState(false);
    const handleClose16 = () => {setShow16(false);setShow1(true)};
    const [show17, setShow17] = useState(false);
    const handleClose17 = () => {setShow17(false);setShow1(true)};
    const [show18, setShow18] = useState(false);
    const handleClose18 = () => {setShow18(false);setShow1(true)};
    const [show19, setShow19] = useState(false);
    const handleClose19 = () => {setShow19(false);setShow1(true)};
    const [show20, setShow20] = useState(false);
    const handleClose20 = () => {setShow20(false);setShow1(true)};
    const [show21, setShow21] = useState(false);
    const handleClose21 = () => {setShow21(false);setShow1(true)};
    const [show22, setShow22] = useState(false);
    const handleClose22 = () => {setShow22(false);setShow1(true)};
    const [show23, setShow23] = useState(false);
    const handleClose23 = () => {setShow23(false);setShow1(true)};
    const [show41, setShow41] = useState(false);
    const handleClose41 = () => {setShow41(false);setShow1(true)};
    const [show42, setShow42] = useState(false);
    const handleClose42 = () => {setShow42(false);setShow1(true)};
    const [show43, setShow43] = useState(false);
    const handleClose43 = () => {setShow43(false);setShow1(true)};
    const [show44, setShow44] = useState(false);
    const handleClose44 = () => {setShow44(false);setShow1(true)};
    const [show45, setShow45] = useState(false);
    const handleClose45 = () => {setShow45(false);setShow1(true)};
    const [show24, setShow24] = useState(false);
    const handleClose24 = () => {setShow24(false);setShow1(true)};
    useEffect(() => {
        const thisshowed = localStorage.getItem("convozeplayed");
        if(!thisshowed){
            setShow1(true);
            localStorage.setItem("convozeplayed", "You got it");
        }
    }, []);
    useEffect(() => {
        Auth.currentAuthenticatedUser()
            .then(user => {
                setIsUser(user.attributes.email);
                setIsUsere(user.attributes.email);
                const username = user.attributes.email;
                try {
                    API.graphql({
                        query: listHosts,
                        variables: {
                            filter: {
                                "owner": {
                                    eq: username
                                }
                            },
                            limit: 10000
                        }
                    }).then(datas => {
                        const players = datas.data.listHosts.items;
                        const sids = players[0].status;
                        if(sids) {
                            const options = {
                                method: 'GET',
                                headers: {
                                    accept: 'application/json',
                                    ApiKey: 'click-video_6598e22a7257474591cab3ad5b4211ff'
                                }
                            };
                            fetch(`https://public.billsby.com/api/v1/rest/core/reachum/subscriptions/${sids}`, options)
                                .then(response => response.json())
                                .then(response => {
                                        const rs = response.status;
                                        const thisplan = response.planId;
                                        if (rs === "Active") {
                                            if (thisplan === 35027) {
                                                setIsthisplan(false);
                                                setIsthislink("share")
                                            }
                                        }
                                        if (rs === "Cancelled") {
                                            history.replace("/pricing");
                                        }
                                    }
                                )
                                .catch(err => console.error(err));
                        }
                    })
                }catch (error){
                    console.log(error)
                }

            })
            .catch(err => console.log(err));
        fetchData();
        fetchcata();
        const deletePlayslide = API.graphql(
            {
                query:newDeletePlayslide
            }
        ).subscribe({
            next: () => {
                fetchData();
            }
        })
        const updatePlayslide = API.graphql(
            {
                query:newUpdatePlayslide
            }
        ).subscribe({
            next: () => {
                fetchData();
            }
        })
        return()=>{
            deletePlayslide.unsubscribe();
            updatePlayslide.unsubscribe()
        }
    }, []);
    async function fetchData() {
        const response =  await API.graphql({
            query: getPlayslide,
            variables: { id }
        });
        const datas = response.data.getPlayslide;
        const iowner = datas.owner;
        setIsOwner(iowner);
        const emeeting = datas.meetingname;
        setYmeeting(emeeting);
        const emeetingid = datas.mid;
        setYmeetingid(emeetingid);
        const edatas = datas.playlistlinks;
        if(edatas === null){
            console.log("hello");
        }else {
            setPlaycontents(edatas);
            setDuplicateopen(false)
        }
    }
    async function fetchcata() {
        const response = await API.graphql({
            query: listPlayslides
        });
        const datas = response.data.listPlayslides.items;
        setCondata(datas);
    }
    const handleChange = (e, id) => {
        e.preventDefault();
        const newContentIndex = playcontents.findIndex(content => content.rid === id);
        const newContent = playcontents[newContentIndex];
        newContent.title = e.target.value;
        const clonedPlaycontents = [...playcontents];
        clonedPlaycontents.splice(newContentIndex, 1, newContent);
        setPlaycontents(clonedPlaycontents);
    }
    const sid = id;
    const handleDelete = async (id) => {
        const newPlayContents = playcontents.filter(content => content.rid !== id);
        try {
            const input = {
                id: sid,
                playlistlinks: newPlayContents
            };
            await API.graphql({
                query: updatePlayslide,
                variables: {input}
            });
        }catch(err){
            console.log(err)
        }
        setPlaycontents(newPlayContents);
    }
    const  handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const input = {
                id,
                playlistlinks: playcontents
            };
            await API.graphql({
                query: updatePlayslide,
                variables: {input}
            });
        }catch(err){
            console.log(err)
        }
        setChangesavedmessage("Saved")
        setTimeout(() => {
            setChangesavedmessage("")
        }, 1000);
    }
    async function changeroomname(event){
        event.preventDefault();
        setYmeeting(event.target.value);
    }

    useEffect(() => {
        const delay = 2000;
        const timeoutId = setTimeout(() => {
            saveInputValue(ymeeting);
        }, delay);
        return () => {
            clearTimeout(timeoutId);
        };
    }, [ymeeting]);

    const saveInputValue = async (value) => {
        try {
            const input = {
                id,
                meetingname: value
            };
            await API.graphql({
                query: updatePlayslide,
                variables: {input}
            });
        } catch (err) {
            console.log(err)
        }
    };
    function gobackthis(){
        history.push(`/c`);
    }
    function openipqrcodeage(){
        window.open(`https://edu.reachum.com/ipqrcodepage/${id}`, "Reachum in-Person QR code", "popup" )
    }
    const renderDatalinks = () => {
        return (
            <ListGroup.Item >
                <Tabs
                    defaultActiveKey="share"
                    id="uncontrolled-tab-example"
                    className="mb-3"
                >
                    <Tab eventKey="full" title="Remote" disabled>
                    </Tab>
                    <Tab eventKey="share" title="In-Person">
                        {openipinfomation ?
                            <>
                                <Grid container spacing={0} className="topspace1">
                                    <Grid item xs={1} className="cccenter">
                                    </Grid>
                                    <Grid item xs={5} className="cccenter">
                                        <button onClick={() => {
                                            window.open(`/ihost/${id}/${ymeetingid}`, "_blank");
                                        }} className="newstartbuttoncolor">
                                            Start Lesson
                                        </button>
                                    </Grid>
                                    <Grid item xs={5} className="cccenter">
                                        <button className="newcalendarbuttoncolor" onClick={() => {
                                            setOpenipinfomation(false);
                                            setOpenipcalenders(true);
                                            setOpenipexplainer(false)
                                        }}>Calendar Invite
                                        </button>
                                    </Grid>
                                    <Grid item xs={1} className="cccenter">
                                    </Grid>
                                </Grid>
                                <br/>
                                <div className="cccenter">
                                    <p className="newunderline" onClick={()=>{
                                        setOpenipinfomation(false);
                                        setOpenipcalenders(false);
                                        setOpenipexplainer(true)
                                    }}> View the Host Control Guide.</p>
                                </div>
                                <br/>
                                <div className="cccenter">
                                    <p> Click the button below to copy the In-Person class link.</p>
                                    <br/>
                                    <Grid container spacing={0}>
                                        <Grid item xs={1} className="cccenter">
                                        </Grid>
                                        <Grid item xs={5}>
                                            <CopyToClipboard text={`https://edu.reachum.com/iview/${id}`} onCopy={() => {
                                                setCiopied(true);
                                                setTimeout(() => {
                                                    setCiopied(false);
                                                }, 5000);
                                            }}>
                                                <button className="newclasslinksbutton"> Student Link </button>
                                            </CopyToClipboard>
                                            {icopied ? <span style={{color: 'red'}}> Copied </span> : null}
                                        </Grid>
                                        <Grid item xs={5}>
                                            <button className="newclasslinksbutton" onClick={openipqrcodeage}>Generate QR Code</button>
                                        </Grid>
                                        <Grid item xs={1} className="cccenter">
                                        </Grid>
                                    </Grid>
                                </div>
                                <br/>
                                <br/>
                            </> :
                            <div>
                                <p className="sharedropbtn" onClick={()=> setOpenipinfomation(true)}><img src={Leftarrow} width="13" height="13" alt="go back to remote lesson links"/> <span className="roomlistbutton"> In-Person Lesson Links </span> </p>
                                {openipcalenders ?
                                    <div>
                                        <div className="cccenter">
                                            <h5>Invite Students</h5>
                                        </div>
                                        <Inviteform1 data={id}/>
                                    </div>
                                    : ""
                                }
                                {openipexplainer ?
                                    <div>
                                        <div className="cccenter">
                                            <h5>Host Control Guide</h5>
                                            <br/>
                                            <p>Confused on how to use REACHUM In-Person? Don’t worry! We got your back.<br/>
                                                Hover over an icon below to see what it does.</p>
                                        </div>
                                        <br/>
                                        <div className="cccenter">
                                            <div className="upgradenew2">
                                                <img src={Maxs} width="50px" alt="Max" className="leftmargin"/>
                                                <span className="tooltiptext2">Maximize View button: <br/>
Maximize your screen and bring your lesson into focus.
</span>
                                            </div>
                                            <div className="upgradenew2">
                                                <img src={Slidelist} width="50px" alt="slide list" className="leftmargin"/>
                                                <span className="tooltiptext2">Content List button: <br/>
Skip forward or backward in your lesson with a single click. Open your list and click on the desired slide. Then, when you’re done reviewing, click the “next” button to return to the slide after your previous one.
</span>
                                            </div>
                                            <div className="upgradenew2">
                                                <img src={Timer} width="50px" alt="timer button" className="leftmargin"/>
                                                <span className="tooltiptext2">Timer button: <br/>
Instantly start 1 minute timer at any point in your class. The timer button is a great classroom management tool that comes in handy for keeping group discussions, writing prompts, and other class activities on track. Click to toggle between showing and hiding.
</span>
                                            </div>
                                            <div className="upgradenew2">
                                                <img src={Qrcodes} width="50px" alt="QR code" className="leftmargin"/>
                                                <span className="tooltiptext2">QR Code button: <br/>
Instantly pull up a QR code at any point in your class so users who are late to a class can still participate. Click to toggle between showing and hiding.
</span>
                                            </div>
                                            <div className="upgradenew2">
                                                <img src={Whiteboards} width="50px" alt="Whiteboard" className="leftmargin"/>
                                                <span className="tooltiptext2">Whiteboard button: <br/>
Pull up a whiteboard and write on it with your mouse cursor during your lesson. This whiteboard is not collaborative and will not show up on participant devices. Click to toggle between showing and hiding.
                                                </span>
                                            </div>
                                            <div className="upgradenew2">
                                                <img src={Maths} width="50px" alt="math" className="leftmargin"/>
                                                <span className="tooltiptext2">Math Whiteboard button: <br/>
Pull up a math whiteboard and solve mathematical problems using Desmos graphing calculator to create visual representations of solutions. This whiteboard is not collaborative and will not show up on participant devices. Click to toggle between showing and hiding.
</span>
                                            </div>
                                        </div>
                                        <br/>
                                        <div className="cccenter">
                                            <div className="upgradenew2">
                                                <img src={Plays} width="50px" alt="play button" className="leftmargin"/>
                                                <span className="tooltiptext2">Play button: <br/>
Begin a self-embedded video. (Note: Does not work on video links such as linked YouTube videos. To view a YouTube video, click the YouTube play icon in the center of the screen.)
</span>
                                            </div>
                                            <div className="upgradenew2">
                                                <img src={Syns} width="50px" alt="Sync button" className="leftmargin"/>
                                                <span className="tooltiptext2">Sync button: <br/>
If you manually move forward or backward in a self-embedded video while the video is paused, you’ll see the sync button pop up above the video progress bar. Click the sync button to sync the video playback across all student devices to your own.
</span>
                                            </div>
                                            <div className="upgradenew2">
                                                <img src={Backs} width="50px" alt="back" className="leftmargin"/>
                                                <span className="tooltiptext2">Back button: <br/> Move to the previous slide in your REACHUM presentation. </span>
                                            </div>
                                            <div className="upgradenew2">
                                                <img src={Nexts} width="50px" alt="next" className="leftmargin"/>
                                                <span className="tooltiptext2">Next button: <br/>
Move to the next slide in your REACHUM presentation.
 </span>
                                            </div>
                                        </div>
                                        <br/>
                                        <br/>
                                    </div>
                                    : ""
                                }
                            </div>
                        }
                    </Tab>
                    <Tab eventKey="selfstudy" title="Self-Study" disabled>
                    </Tab>
                </Tabs>
            </ListGroup.Item>

        )
    }
    function thiszoomin(){
        setIsopen(false);
        const allWithClass = Array.from(
            document.querySelectorAll('div.lialist')
        );
        const allWithClass1 = Array.from(
            document.querySelectorAll('img.editnoi')
        );
        const allWithClass2 = Array.from(
            document.querySelectorAll('iframe.editsframelook')
        );
        allWithClass.forEach(element => {
            element.style.width = "141px";
            element.style.height = "120px";
        });
        allWithClass1.forEach(element => {
            element.style.width = "137px";
            element.style.height = "51px";
        });
        allWithClass2.forEach(element => {
            element.style.width = "137px";
            element.style.height = "51px";
        });
    }
    function thiszoomout(){
        setIsopen(true);
        const allWithClass = Array.from(
            document.querySelectorAll('div.lialist')
        );
        const allWithClass1 = Array.from(
            document.querySelectorAll('img.editnoi')
        );
        const allWithClass2 = Array.from(
            document.querySelectorAll('iframe.editsframelook')
        );
        allWithClass.forEach(element => {
            element.style.width = "235px";
            element.style.height = "200px";
        });
        allWithClass1.forEach(element => {
            element.style.width = "229px";
            element.style.height = "130px";
        });
        allWithClass2.forEach(element => {
            element.style.width = "229px";
            element.style.height = "130px";
        });
    }
    function answeraquestionfunctions(){
        history.push(`/eanswer/${id}`);
    }
    const sensors = useSensors(
        useSensor(PointerSensor, {
            activationConstraint: {
                distance: 5
            }
        }),
    );
    const [selectedIds, setSelectedIds] = useState([])
    function selectId (id) {
        setSelectedIds(current => {
            return [...current, id]
        })
    }
    function toggleSelect(id) {
        setSelectedIds(current => {
            const selected = current.includes(id)
            if (selected) {
                return current.filter(currentId => currentId !== id)
            } else {
                return [...current, id]
            }
        })
    }
    const itemViews = playcontents.map((itm, index) => {
        function handleMouseDown() {
            toggleSelect(itm.rid)
        }
        const selected = selectedIds.includes(itm.rid)
        return (
            <SortableItem
                key={itm.rid}
                id={itm.rid}
                selected={selected}
            >
                <div className="lialist">
                    <Grid container spacing={0} className="topedit">
                        <Grid item xs={3} className="leftside">
                            <div className="upgradenew2" onMouseDown={handleMouseDown}>
                                <img src={Allmove} width="12" height="12" className="movethis"/>
                                <span className="editspan">{Number(index) + Number(1)}</span>
                                <span className="tooltiptext2">Choose the items you want to rearrange, and then drag them to reorder.</span>
                            </div>
                        </Grid>
                        <Grid item xs={3}>
                            {!itm.adobeprojectid ?
                                <div className="upgradenew2">
                                    <img src={Editb} onClick={() => {
                                        setEurls(itm.eurl);
                                        setShow(true);
                                    }} width="18" height="18"/>
                                    <span className="tooltiptext2">Click here to edit the content.</span>
                                </div>
                                : ""
                            }
                        </Grid>
                        <Grid item xs={4} className="leftside">
                        </Grid>
                        <Grid item xs={2} className="rightside">
                            <div className="upgradenew1">
                                <img src={DeleteIcon} width="18" height="18" onClick={() => {
                                    handleDelete(itm.rid);
                                }} />
                                <span className="tooltiptext1">Click to delete</span>
                            </div>
                        </Grid>
                    </Grid>
                    <div className="imgslist">
                        <div className="upgradenew1">
                            <div className="imgslist">
                                <img src={Noi} className="editnoi" onClick={() => {
                                    setPurls(itm.rurl);
                                    setIndexs(index);
                                    setTitless(itm.title);
                                    setShow2(true);
                                }} />
                                <iframe src={itm.rurl} scrolling="no" className="editsframelook" loading="lazy"></iframe>
                            </div>
                            <span className="tooltiptext1">Click to preview</span>
                        </div>
                    </div>
                    <input
                        value={itm.title}
                        onChange={(e) => {
                            handleChange(e, itm.rid);
                            if (e.keyCode === 13){
                                handleSubmit();
                            }
                        }}
                        name="title"
                        placeholder="title"
                        className="editroomlist"
                    />
                </div>
            </SortableItem>
        )
    })
    const selectedItems = playcontents.filter(item => {
        return selectedIds.includes(item.rid)
    })
    const overlayViews = selectedItems.map((item,index) => {
        return (
            <SortableItem
                key={item.rid}
                id={item.rid}
                selected
            >
                <div className="centerthis">
                    <br/>
                    <br/>
                    <p>{item.title}</p>
                </div>
            </SortableItem>
        )
    })
    function handleDragStart ({ active }) {
        selectId(active.id)
    }
    function handleDragEnd(event) {
        const { active, over } = event;
        setPlaycontents((current) => {
            const overSelected = selectedIds.includes(over.id)
            if (overSelected) {
                const withoutSelectedExceptOver = current.filter(item => {
                    const selected = selectedIds.includes(item.rid)
                    if (!selected) {
                        return true
                    }
                    const overItem = item.rid === over.id
                    if (overItem) {
                        return true
                    }
                    return false
                })
                const newOverIndex = withoutSelectedExceptOver.findIndex(item => item.rid === over.id)
                const beforeNewOver = withoutSelectedExceptOver.slice(0, newOverIndex)
                const afterNewOver = withoutSelectedExceptOver.slice(newOverIndex + 1)
                const selectedItems = current.filter(item => {
                    return selectedIds.includes(item.rid)
                })
                const newItems = [...beforeNewOver, ...selectedItems, ...afterNewOver]
                return newItems
            } else {
                const activeIndex = current.findIndex(item => item.rid === active.id)
                const overIndex = current.findIndex(item => item.rid === over.id)
                const forward = overIndex > activeIndex
                const selectedItems = current.filter(item => {
                    return selectedIds.includes(item.rid)
                })
                const newWithout = current.filter(item => {
                    return !selectedIds.includes(item.rid)
                })
                const newOverIndex = newWithout.findIndex(item => item.rid === over.id)
                const overFirst = newOverIndex === 0
                if (overFirst && !forward) {
                    return [...selectedItems, ...newWithout]
                }
                const offset = forward ? 1 : 0
                const beforeNew = newWithout.slice(0, newOverIndex + offset)
                const afterNew = newWithout.slice(newOverIndex + offset)
                const newArray = [...beforeNew, ...selectedItems, ...afterNew]
                return newArray
            }
        });
        setSelectedIds([])
    }
    return (
        isOwner === isUser ?
        <>
            <Helmet>
                <title>SafeAsk Content Manager</title>
            </Helmet>
            <Navbars />
            <div className="editroom">
                <div className="input-container">
                    <input type="text" value={ymeeting} onChange={changeroomname} className="editroomnamebig" /><img src={Editbs} className="inputicon" width="28px"/>
                </div>
                <br/>
                <div className="savesheader">
                        <Grid container spacing={0} className="topspace1">
                            <Grid item xs={3}>
                                <h5 className="sharedropbtn" onClick={gobackthis}><img src={Leftarrow} width="13" height="13" alt="go back to dashboard"/> <span className="roomlistbutton">Lesson List</span> </h5>
                            </Grid>
                            <Grid item xs={6} className="cccenter">
                                <span className="editcontents">Content Manager</span>
                            </Grid>
                            <Grid item xs={3} className="cccenter">
                            </Grid>
                        </Grid>
                </div>
                    <div className="saves">
                        <Grid container spacing={0} className="topspace">
                            <Grid item xs={3}>
                                <button className="rehearsebutton disabledimages" disabled>Rehearse</button>
                            </Grid>
                            <Grid item xs={6} className="cccenter">
                            </Grid>
                            <Grid item xs={3} className="cccenter">
                            </Grid>
                        </Grid>
                        <Grid container spacing={0} className="topspace">
                            <Grid item xs={3} className="cccenter">
                                <button onClick={() => {
                                    setShow3(true);
                                }} className="golivebutton">Lesson Links</button>
                            </Grid>
                            <Grid item xs={6} className="centerside">
                            </Grid>
                            <Grid item xs={3} className="cccenter">
                                <button className="addcontentbtn" onClick={()=>setShow1(true)}> Add Content</button>
                            </Grid>
                        </Grid>
                    </div>
                      <Form onSubmit={handleSubmit}>
                          <div className="saveseditchage">
                              <Grid container spacing={0} className="topspace">
                                  <Grid item xs={3} className="cccenter">
                                  </Grid>
                                  <Grid item xs={6} className="cccenter">
                                      <span className="redthis">{changesavedmessage} </span><input type="submit" value="Save Changes" className="inputsavechanges" />
                                  </Grid>
                                  <Grid item xs={3} className="cccenter">
                                      <div className="zooms">
                                          {isopen ?
                                              <img src={Zoomin} onClick={thiszoomin} width="32" height="32" alt="zoom in"/>
                                              :
                                              <img src={Zoomout} onClick={thiszoomout} width="32" height="32" alt="zoom out"/>
                                          }
                                      </div>
                                  </Grid>
                              </Grid>
                          </div>
                          <DndContext
                              sensors={sensors}
                              collisionDetection={closestCenter}
                              onDragEnd={handleDragEnd}
                              onDragStart={handleDragStart}
                          >
                              <SortableContext items={playcontents}>
                                  {itemViews}
                              </SortableContext>
                              <DragOverlay>
                                  {overlayViews}
                              </DragOverlay>
                          </DndContext>
                    <br/>
            </Form>
            </div>
            <Modal show={show1} onHide={handleClose1} aria-labelledby="contained-modal-title-vcenter" size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Add Content</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="redthis">For full access to REACHUM's features, subscribe now.</p>
                    <Tabs
                        defaultActiveKey="discussion"
                        id="uncontrolled-tab-example"
                        className="mb-3"
                    >
                        <Tab eventKey="resources" title="Media">
                            <br/>
                            <Grid container spacing={0} className="topspace">
                                <Grid item xs={2} className="cccenter">
                                    <img src={Adobeexpress} width="80px" alt="Adobe Express" className="disabledimages"/>
                                    <br/>
                                    <img src={Info} onClick={()=>{setShow1(false);setShow23(true)}} width="30px" alt="Info" />
                                </Grid>
                                <Grid item xs={2} className="cccenter">
                                    <img src={Slide} width="80px" alt="Text Slide" className="disabledimages"/>
                                    <br/>
                                    <img src={Info} onClick={()=>{setShow1(false);setShow31(true)}} width="30px" alt="Info"/>
                                </Grid>
                                <Grid item xs={2} className="cccenter">
                                    <img src={Image} width="80px" alt="Upload Image" className="disabledimages"/>
                                    <br/>
                                    <img src={Info} onClick={()=>{setShow1(false);setShow32(true)}} width="30px" alt="Info"/>
                                </Grid>
                                <Grid item xs={2} className="cccenter">
                                    <img src={Video} width="80px" alt="Upload Video" className="disabledimages"/>
                                    <br/>
                                    <img src={Info} onClick={()=>{setShow1(false);setShow33(true)}} width="30px" alt="Info"/>
                                </Grid>
                                <Grid item xs={2} className="cccenter">
                                    <img src={Powerponit} width="80px" alt="Upload Powerpoint" className="disabledimages"/>
                                    <br/>
                                    <img src={Info} onClick={()=>{setShow1(false);setShow34(true)}} width="30px" alt="Info"/>
                                </Grid>
                                <Grid item xs={2} className="cccenter">
                                    <img src={Pdf} width="80px" alt="Upload PDF" className="disabledimages"/>
                                    <br/>
                                    <img src={Info} onClick={()=>{setShow1(false);setShow35(true)}} width="30px" alt="Info"/>
                                </Grid>
                            </Grid>
                            <br/>
                            <Grid container spacing={0} className="topspace">
                                <Grid item xs={2} className="cccenter">
                                    <img src={Gif} width="80px" alt="Upload GIF" className="disabledimages"/>
                                    <br/>
                                    <img src={Info} onClick={()=>{setShow1(false);setShow36(true)}} width="30px" alt="Info"/>
                                </Grid>
                                <Grid item xs={2} className="cccenter">
                                    <img src={Link} width="80px" alt="Upload URL" className="disabledimages"/>
                                    <br/>
                                    <img src={Info} onClick={()=>{setShow1(false);setShow37(true)}} width="30px" alt="Info"/>
                                </Grid>
                                <Grid item xs={2} className="cccenter">
                                    <img src={Videolink} width="80px" alt="Upload Video" className="disabledimages"/>
                                    <br/>
                                    <img src={Info} onClick={()=>{setShow1(false);setShow38(true)}} width="30px" alt="Info"/>
                                </Grid>
                                <Grid item xs={2} className="cccenter">
                                    <img src={Draw} width="80px" alt="Draw" className="disabledimages"/>
                                    <br/>
                                    <img src={Info} onClick={()=>{setShow1(false);setShow39(true)}} width="30px" alt="Info"/>
                                </Grid>
                                <Grid item xs={2} className="cccenter">
                                    <img src={Record} width="80px" alt="Record Video" className="disabledimages"/>
                                    <br/>
                                    <img src={Info} onClick={()=>{setShow1(false);setShow10(true)}} width="30px" alt="Info"/>
                                </Grid>
                                <Grid item xs={2} className="cccenter">
                                    <img src={Giphy} width="80px" alt="Giphy" className="disabledimages"/>
                                    <br/>
                                    <img src={Info} onClick={()=>{setShow1(false);setShow11(true)}} width="30px" alt="Info"/>
                                </Grid>
                            </Grid>
                            <br/>
                            <Grid container spacing={0} className="topspace">
                                <Grid item xs={2} className="cccenter">
                                    <img src={Flashcardsicon} width="80px" className="disabledimages"/>
                                    <br/>
                                    <img src={Info} onClick={()=>{setShow1(false);setShow41(true)}} width="30px" alt="Info"/>
                                </Grid>
                                <Grid item xs={2} className="cccenter">
                                    <img src={Mathslideicon} width="80px" className="disabledimages"/>
                                    <br/>
                                    <img src={Info} onClick={()=>{setShow1(false);setShow42(true)}} width="30px" alt="Info"/>
                                </Grid>
                                <Grid item xs={2} className="cccenter">
                                </Grid>
                                <Grid item xs={2} className="cccenter">
                                </Grid>
                                <Grid item xs={2} className="cccenter">
                                </Grid>
                                <Grid item xs={2} className="cccenter">
                                </Grid>
                            </Grid>
                            <br/>
                        </Tab>
                        <Tab eventKey="discussion" title="Discussion Questions">
                            <br/>
                            <div className="leftpadding">
                                <p>Discussion questions are meant to generate conversation. These activities have no correct answers and responses will not be reflected on your leaderboard.</p>
                            </div>
                            <Grid container spacing={0} className="topspace">
                                <Grid item xs={3} className="cccenter">
                                    <img src={Polls} width="80px" alt="Polls" className="disabledimages"/>
                                    <br/>
                                    <img src={Info} onClick={()=>{setShow1(false);setShow12(true)}} width="30px" alt="Info"/>
                                </Grid>
                                <Grid item xs={3} className="cccenter">
                                    <img src={Rankingmenu} width="80px" alt="Ranking Poll" className="disabledimages"/>
                                    <br/>
                                    <img src={Info} onClick={()=>{setShow1(false);setShow40(true)}} width="30px" alt="Info"/>
                                </Grid>
                                <Grid item xs={3} className="cccenter">
                                    <img src={Open} onClick={answeraquestionfunctions} alt="SafeAsk" width="80px" alt="Convoze"/>
                                    <br/>
                                    <img src={Info} onClick={()=>{setShow1(false);setShow13(true)}} width="30px" alt="Info"/>
                                </Grid>
                                <Grid item xs={3} className="cccenter">
                                    <img src={Wordcloud} width="80px" alt="Word Cloud" className="disabledimages"/>
                                    <br/>
                                    <img src={Info} onClick={()=>{setShow1(false);setShow24(true)}} width="30px"/>
                                </Grid>
                            </Grid>
                            <br/>
                        </Tab>
                        <Tab eventKey="leaderboard" title="Leaderboard Games">
                            <br/>
                            <div className="leftpadding">
                                <p>Leaderboard games are designed to engage your learners in friendly, time-based competition. The quicker a learner guesses the correct answer, the more points they earn on the leaderboard.</p>
                            </div>
                            <Grid container spacing={0} className="topspace">
                                <Grid item xs={2} className="cccenter">
                                    <img src={Single} width="80px" alt="Single Option" className="disabledimages"/>
                                    <br/>
                                    <img src={Info} onClick={()=>{setShow1(false);setShow14(true)}} width="30px" alt="Info"/>
                                </Grid>
                                <Grid item xs={2} className="cccenter">
                                    <img src={Multi} width="80px" alt="Multi Options" className="disabledimages"/>
                                    <br/>
                                    <img src={Info} onClick={()=>{setShow1(false);setShow15(true)}} width="30px" alt="Info"/>
                                </Grid>
                                <Grid item xs={2} className="cccenter">
                                    <img src={Fill} width="80px" alt="Fill in the Blank" className="disabledimages"/>
                                    <br/>
                                    <img src={Info} onClick={()=>{setShow1(false);setShow16(true)}} width="30px" alt="Info"/>
                                </Grid>
                                <Grid item xs={2} className="cccenter">
                                    <img src={Drawquiz} width="80px" alt="Draw Quize" className="disabledimages"/>
                                    <br/>
                                    <img src={Info} onClick={()=>{setShow1(false);setShow17(true)}} width="30px" alt="Info"/>
                                </Grid>
                                <Grid item xs={2} className="cccenter">
                                    <img src={Videoquiz} width="80px" alt="Video Quize" className="disabledimages"/>
                                    <br/>
                                    <img src={Info} onClick={()=>{setShow1(false);setShow18(true)}} width="30px" alt="Info"/>
                                </Grid>
                                <Grid item xs={2} className="cccenter">
                                    <img src={Memory} width="80px" alt="Memory Matching Game" className="disabledimages"/>
                                    <br/>
                                    <img src={Info} onClick={()=>{setShow1(false);setShow20(true)}} width="30px" alt="Info"/>
                                </Grid>
                            </Grid>
                            <br/>
                            <Grid container spacing={0} className="topspace">
                                <Grid item xs={2} className="cccenter">
                                    <img src={Drag} width="80px" alt="Tap Tap" className="disabledimages"/>
                                    <br/>
                                    <img src={Info} onClick={()=>{setShow1(false);setShow21(true)}} width="30px" alt="Info"/>
                                </Grid>
                                <Grid item xs={2} className="cccenter">
                                    <img src={Sequecing} width="80px" alt="Sequencing" className="disabledimages"/>
                                    <br/>
                                    <img src={Info} onClick={()=>{setShow1(false);setShow22(true)}} width="30px" alt="Info"/>
                                </Grid>
                                <Grid item xs={2} className="cccenter">
                                    <img src={Math} width="80px" alt="Math" className="disabledimages"/>
                                    <br/>
                                    <img src={Info} onClick={()=>{setShow1(false);setShow19(true)}} width="30px" alt="Info"/>
                                </Grid>
                                <Grid item xs={2} className="cccenter">
                                    <img src={Mathfill} width="80px" className="disabledimages"/>
                                    <br/>
                                    <img src={Info} onClick={()=>{setShow1(false);setShow43(true)}} width="30px" alt="Info"/>
                                </Grid>
                                <Grid item xs={2} className="cccenter">
                                    <img src={Mathmul} width="80px" className="disabledimages"/>
                                    <br/>
                                    <img src={Info} onClick={()=>{setShow1(false);setShow44(true)}} width="30px" alt="Info"/>
                                </Grid>
                                <Grid item xs={2} className="cccenter">
                                    <img src={Mathseq} width="80px" className="disabledimages"/>
                                    <br/>
                                    <img src={Info} onClick={()=>{setShow1(false);setShow45(true)}} width="30px" alt="Info"/>
                                </Grid>
                            </Grid>
                        </Tab>
                    </Tabs>
                </Modal.Body>
                <Modal.Footer>
                </Modal.Footer>
            </Modal>
            <Modal show={show2} onHide={handleClose2} aria-labelledby="contained-modal-title-vcenter" size="xl" centered>
                <Modal.Header closeButton>
                    <Modal.Title>{indexs+1}. {titless}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {purls !== "" && (
                        <iframe
                            src={purls}
                            width="100%"
                            loading="lazy"
                            height="700px"
                            title="maincontent"
                            frameBorder="0"
                            allow="fullscreen,autoplay"
                        />
                    )}
                </Modal.Body>
                <Modal.Footer>
                </Modal.Footer>
            </Modal>
            <Modal show={show} onHide={handleClose} aria-labelledby="contained-modal-title-vcenter" size="xl" centered>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    {eurls !== "" && (
                        <iframe
                            src={eurls}
                            width="100%"
                            loading="lazy"
                            height="700px"
                            title="maincontents"
                            frameBorder="0"
                            allow="fullscreen"
                        />
                    )}
                </Modal.Body>
                <Modal.Footer>
                </Modal.Footer>
            </Modal>
            <Modal show={show3} onHide={handleClose3} aria-labelledby="contained-modal-title-vcenter" size="xl" centered>
                <Modal.Header closeButton>
                    {ymeeting} - Lesson Links
                </Modal.Header>
                <Modal.Body>
                    {renderDatalinks()}
                </Modal.Body>
            </Modal>
            <Modal show={show31} onHide={handleClose31} aria-labelledby="contained-modal-title-vcenter" size="lg" centered>
                <Modal.Header closeButton>
                    <span className="redthis">Text Slide</span>
                </Modal.Header>
                <Modal.Body>
                    <div className="disfullcenter">
                        <img src={Textslidedis}  className="disfull" alt="Text Slide"/>
                    <br/>
                    <br/>
                    <p>Create an editable text slide with our rich text editor. Use this tool to create a simple slide or a complex navigation menu.</p>
                    </div>
                        <br/>
                    <br/>
                </Modal.Body>
            </Modal>
            <Modal show={show32} onHide={handleClose32} aria-labelledby="contained-modal-title-vcenter" size="lg" centered>
                <Modal.Header closeButton>
                    <span className="redthis">Image</span>
                </Modal.Header>
                <Modal.Body>
                    <div className="disfullcenter">
                        <img src={Imagedis}  className="disfull" alt="Image"/>
                    <br/>
                    <br/>
                    <p>Upload a jpeg or png image.</p>
                    </div>
                    <br/>
                    <br/>
                </Modal.Body>
            </Modal>
            <Modal show={show33} onHide={handleClose33} aria-labelledby="contained-modal-title-vcenter" size="lg" centered>
                <Modal.Header closeButton>
                    <span className="redthis">Video</span>
                </Modal.Header>
                <Modal.Body>
                    <div className="disfullcenter">
                        <img src={Videodis}  className="disfull" alt="Video"/>
                    <br/>
                    <br/>
                    <p>Upload a video for precise playback control across all student devices.</p>
                    </div>
                    <br/>
                    <br/>
                </Modal.Body>
            </Modal>
            <Modal show={show34} onHide={handleClose34} aria-labelledby="contained-modal-title-vcenter" size="lg" centered>
                <Modal.Header closeButton>
                    <span className="redthis">PowerPoint</span>
                </Modal.Header>
                <Modal.Body>
                    <div className="disfullcenter">
                        <img src={Pptxdis}  className="disfull" alt="PowerPoint"/>
                    <br/>
                    <br/>
                    <p>Upload a PowerPoint deck. PowerPoint files are converted to separate static images that can be reordered or deleted within the REACHUM platform.</p>
                    </div>
                        <br/>
                    <br/>
                </Modal.Body>
            </Modal>
            <Modal show={show35} onHide={handleClose35} aria-labelledby="contained-modal-title-vcenter" size="lg" centered>
                <Modal.Header closeButton>
                    <span className="redthis">PDF</span>
                </Modal.Header>
                <Modal.Body>
                    <div className="disfullcenter">
                        <img src={Pdfdis}  className="disfull" alt="PDF"/>
                    <br/>
                    <br/>
                    <p>Upload a PDF. PDF pages are converted to individual slides that can be reordered or deleted within the REACHUM platform.</p>
                    </div>
                        <br/>
                    <br/>
                </Modal.Body>
            </Modal>
            <Modal show={show36} onHide={handleClose36} aria-labelledby="contained-modal-title-vcenter" size="lg" centered>
                <Modal.Header closeButton>
                    <span className="redthis">GIF</span>
                </Modal.Header>
                <Modal.Body>
                    <div className="disfullcenter">
                        <img src={Gifdis}  className="disfull" alt="GIF"/>
                    <br/>
                    <br/>
                    <p>Upload your own animated gifs in REACHUM.</p>
                    </div>
                    <br/>
                    <br/>
                </Modal.Body>
            </Modal>
            <Modal show={show37} onHide={handleClose37} aria-labelledby="contained-modal-title-vcenter" size="lg" centered>
                <Modal.Header closeButton>
                    <span className="redthis">Show Webpage</span>
                </Modal.Header>
                <Modal.Body>
                    <div className="disfullcenter">
                        <img src={Linktodis}  className="disfull" alt="Show Webpage"/>
                    <br/>
                    <br/>
                    <p>Anything available by link is shareable in REACHUM, with full collaboration possible. Work together on documents and spreadsheets, or send a 3rd party quiz, a poll, or a shopping cart for secure, in-class transactions!</p>
                    </div>
                        <br/>
                    <br/>
                </Modal.Body>
            </Modal>
            <Modal show={show38} onHide={handleClose38} aria-labelledby="contained-modal-title-vcenter" size="lg" centered>
                <Modal.Header closeButton>
                    <span className="redthis">Video Link</span>
                </Modal.Header>
                <Modal.Body>
                    <div className="disfullcenter">
                        <img src={Videolinkdis}  className="disfull" alt="Video Link"/>
                    <br/>
                    <br/>
                    <p>YouTube and Vimeo links are shareable in REACHUM.</p>
                    </div>
                    <br/>
                    <br/>
                </Modal.Body>
            </Modal>
            <Modal show={show39} onHide={handleClose39} aria-labelledby="contained-modal-title-vcenter" size="lg" centered>
                <Modal.Header closeButton>
                    <span className="redthis">Draw</span>
                </Modal.Header>
                <Modal.Body>
                    <div className="disfullcenter">
                        <img src={Drawdis}  className="disfull" alt="Draw"/>
                    <br/>
                    <br/>
                    <p>Teachers can share freehand drawings and include poll questions.</p>
                    </div>
                    <br/>
                    <br/>
                </Modal.Body>
            </Modal>
            <Modal show={show10} onHide={handleClose10} aria-labelledby="contained-modal-title-vcenter" size="lg" centered>
                <Modal.Header closeButton>
                    <span className="redthis">Record a Video</span>
                </Modal.Header>
                <Modal.Body>
                    <div className="disfullcenter">
                        <Tabs
                            defaultActiveKey="videoss"
                            id="uncontrolled-tab-example"
                            className="mb-3"
                        >
                            <Tab eventKey="videoss" title="Record video">
                                <img src={Recordvideo1dis}  className="disfull" alt="Record a Video"/>
                            </Tab>
                            <Tab eventKey="displayvideos" title="Play video">
                                <img src={Recordvideo2dis}  className="disfull" alt="Record a Video"/>
                            </Tab>
                        </Tabs>
                    <br/>
                    <br/>
                    <p>REACHUM hosts can record a video up to 2 minutes long.</p>
                    </div>
                    <br/>
                    <br/>
                </Modal.Body>
            </Modal>
            <Modal show={show11} onHide={handleClose11} aria-labelledby="contained-modal-title-vcenter" size="lg" centered>
                <Modal.Header closeButton>
                    <span className="redthis">Giphy Library</span>
                </Modal.Header>
                <Modal.Body>
                    <div className="centerthisgiphy">
                        <img src={Giphydis}  width="360px"/>
                    <br/>
                    <br/>
                    <p>Import a gif to set the  mood using GIPHY, the largest library of animated gifs on the internet.</p>
                    </div>
                        <br/>
                    <br/>
                </Modal.Body>
            </Modal>
            <Modal show={show12} onHide={handleClose12} aria-labelledby="contained-modal-title-vcenter" size="lg" centered>
                <Modal.Header closeButton>
                    <span className="redthis">Polls</span>
                </Modal.Header>
                <Modal.Body>
                    <div className="disfullcenter">
                        <img src={Pollsdis}  className="disfull" alt="Poll"/>
                    <br/>
                    <br/>
                    <p>Measure your audience’s attitude, sentiment, or opinion with a poll.</p>
                    </div>
                    <br/>
                    <br/>
                </Modal.Body>
            </Modal>
            <Modal show={show13} onHide={handleClose13} aria-labelledby="contained-modal-title-vcenter" size="lg" centered>
                <Modal.Header closeButton>
                    <span className="redthis">SafeAsk</span>
                </Modal.Header>
                <Modal.Body>
                    <div className="disfullcenter">
                        <Tabs
                            defaultActiveKey="teacher"
                            id="uncontrolled-tab-example"
                            className="mb-3"
                        >
                            <Tab eventKey="teacher" title="Teacher view">
                                <img src={Openended1dis}  className="disfull" alt="SafeAsk" />
                            </Tab>
                            <Tab eventKey="highlight" title="Spotlight a response">
                                <img src={Openended2dis}  className="disfull" alt="SafeAsk" />
                            </Tab>
                            <Tab eventKey="student" title="Student view">
                                <img src={Openended3dis}  className="disfull" alt="SafeAsk" />
                            </Tab>
                        </Tabs>
                    <br/>
                    <br/>
                    <p>Ask your class an open-ended question and receive identified or anonymous responses. Click on a response to display it on student screens to stimulate conversation.</p>
                    </div>
                        <br/>
                    <br/>
                </Modal.Body>
            </Modal>
            <Modal show={show14} onHide={handleClose14} aria-labelledby="contained-modal-title-vcenter" size="lg" centered>
                <Modal.Header closeButton>
                    <span className="redthis">Single Select</span>
                </Modal.Header>
                <Modal.Body>
                    <div className="disfullcenter">
                        <img src={Singleselectdis}  className="disfull" alt="Single Select"/>
                    <br/>
                    <br/>
                    <p>Teachers ask a question and learners select the single correct answer.</p>
                    </div>
                    <br/>
                    <br/>
                </Modal.Body>
            </Modal>
            <Modal show={show15} onHide={handleClose15} aria-labelledby="contained-modal-title-vcenter" size="lg" centered>
                <Modal.Header closeButton>
                    <span className="redthis">Multi Select</span>
                </Modal.Header>
                <Modal.Body>
                    <div className="disfullcenter">
                        <img src={Multiselectdis}  className="disfull" alt="Multi Select"/>
                    <br/>
                    <br/>
                    <p>Use for questions with more than one correct answer. Scores are weighted by the number of correct answers.</p>
                    </div>
                    <br/>
                    <br/>
                </Modal.Body>
            </Modal>
            <Modal show={show16} onHide={handleClose16} aria-labelledby="contained-modal-title-vcenter" size="lg" centered>
                <Modal.Header closeButton>
                    <span className="redthis">Fill in the Blank</span>
                </Modal.Header>
                <Modal.Body>
                    <div className="disfullcenter">
                        <img src={Fillindis}  className="disfull" alt="Fill in the Blank"/>
                    <br/>
                    <br/>
                    <p>Students type their answer in a single input field. Perfect matches score points.</p>
                    </div>
                    <br/>
                    <br/>
                </Modal.Body>
            </Modal>
            <Modal show={show17} onHide={handleClose17} aria-labelledby="contained-modal-title-vcenter" size="lg" centered>
                <Modal.Header closeButton>
                    <span className="redthis">Draw Quiz</span>
                </Modal.Header>
                <Modal.Body>
                    <div className="disfullcenter">
                        <img src={Drawquizedis}  className="disfull" alt="Draw Quiz"/>
                    <br/>
                    <br/>
                    <p>Teachers draw a picture and ask learners a single select question based on their freehand drawing. Learners select the single correct answer.</p>
                    </div>
                        <br/>
                    <br/>
                </Modal.Body>
            </Modal>
            <Modal show={show18} onHide={handleClose18} aria-labelledby="contained-modal-title-vcenter" size="lg" centered>
                <Modal.Header closeButton>
                    <span className="redthis">Video Quiz</span>
                </Modal.Header>
                <Modal.Body>
                    <div className="disfullcenter">
                                <img src={Videoquiz1dis}  className="disfull" alt="Video Quiz"/>
                    <br/>
                    <br/>
                    <p>Record or upload a video and insert  a timed quiz at a specified time.</p>
                    </div>
                    <br/>
                    <br/>
                </Modal.Body>
            </Modal>
            <Modal show={show19} onHide={handleClose19} aria-labelledby="contained-modal-title-vcenter" size="lg" centered>
                <Modal.Header closeButton>
                    <span className="redthis">Math Quiz</span>
                </Modal.Header>
                <Modal.Body>
                    <div className="disfullcenter">
                        <img src={Mathquizedis}  className="disfull1" alt="Math Quiz"/>
                    <br/>
                    <br/>
                    <p>Single select question using math symbols and notation.</p>
                    </div>
                    <br/>
                    <br/>
                </Modal.Body>
            </Modal>
            <Modal show={show20} onHide={handleClose20} aria-labelledby="contained-modal-title-vcenter" size="lg" centered>
                <Modal.Header closeButton>
                    <span className="redthis">Memory Matching Game</span>
                </Modal.Header>
                <Modal.Body>
                    <div className="disfullcenter">
                        <img src={Mmgdis}  className="disfull" alt="Memory Matching Game"/>
                    <br/>
                    <br/>
                    <p>Click one of 12 cards to flip it over and reveal its value. Click another card to try and find a match. When a match is revealed, the pair disappears.</p>
                    </div>
                    <br/>
                    <br/>
                </Modal.Body>
            </Modal>
            <Modal show={show21} onHide={handleClose21} aria-labelledby="contained-modal-title-vcenter" size="lg" centered>
                <Modal.Header closeButton>
                    <span className="redthis">Tap Tap</span>
                </Modal.Header>
                <Modal.Body>
                    <div className="disfullcenter">
                        <img src={Taptapdis}  className="disfull" alt="Tap Tap"/>
                    <br/>
                    <br/>
                    <p>Users tap a list item to select it and tap the  corresponding category to add. Scores are weighted by the number of correct answers.</p>
                    </div>
                    <br/>
                    <br/>
                </Modal.Body>
            </Modal>
            <Modal show={show22} onHide={handleClose22} aria-labelledby="contained-modal-title-vcenter" size="lg" centered>
                <Modal.Header closeButton>
                    <span className="redthis">Sequecing</span>
                </Modal.Header>
                <Modal.Body>
                    <div className="disfullcenter">
                        <img src={Sequencingdis}  className="disfull1" alt="Sequecing"/>
                    <br/>
                    <br/>
                    <p>Sequencing is useful for assessing timeline knowledge, number sense, process steps, paragraph structures, and more.</p>
                    </div>
                    <br/>
                    <br/>
                </Modal.Body>
            </Modal>
            <Modal show={show40} onHide={handleClose40} aria-labelledby="contained-modal-title-vcenter" size="lg" centered>
                <Modal.Header closeButton>
                    <span className="redthis">Ranking Poll</span>
                </Modal.Header>
                <Modal.Body>
                    <div className="disfullcenter">
                        <img src={Rankingpoll}  className="disfull1" alt="Ranking Poll"/>
                        <br/>
                        <br/>
                        <p>A ranking poll is a survey where people order a list of items by preference. You can use it for elections, product preferences, event planning, decisions, or market research.</p>
                    </div>
                    <br/>
                    <br/>
                </Modal.Body>
            </Modal>
            <Modal show={show23} onHide={handleClose23} aria-labelledby="contained-modal-title-vcenter" size="lg" centered>
                <Modal.Header closeButton>
                    <span className="redthis">Adobe Express</span>
                </Modal.Header>
                <Modal.Body>
                    <div className="disfullcenter">
                        <img src={Adobeoverview}  className="disfull1" alt="Adobe Express"/>
                        <br/>
                        <br/>
                        <p>Adobe Express enables you to create designs more efficiently with access to a vast library of professionally designed templates, Adobe Stock photos, videos, music, and more.</p>
                    </div>
                    <br/>
                    <br/>
                </Modal.Body>
            </Modal>
            <Modal show={show41} onHide={handleClose41} aria-labelledby="contained-modal-title-vcenter" size="lg" centered>
                <Modal.Header closeButton>
                    <span className="redthis">Flashcards</span>
                </Modal.Header>
                <Modal.Body>
                    <div className="disfullcenter">
                        <img src={Flashcardsgif}  className="disfull1" alt="Flashcards"/>
                        <br/>
                        <br/>
                        <p>Flashcards are small cards with a question or information on one side and the corresponding answer or details on the other. They're used for quick and repeated learning to help remember facts, vocabulary, or concepts efficiently.</p>
                    </div>
                    <br/>
                    <br/>
                </Modal.Body>
            </Modal>
            <Modal show={show42} onHide={handleClose42} aria-labelledby="contained-modal-title-vcenter" size="lg" centered>
                <Modal.Header closeButton>
                    <span className="redthis">Math Slide</span>
                </Modal.Header>
                <Modal.Body>
                    <div className="disfullcenter">
                        <img src={Mathslidegif}  className="disfull1" alt="Math Slide"/>
                        <br/>
                        <br/>
                        <p>The Math Slide feature allows you to upload images containing math, create equations, and generate graphics using <span onClick={()=>  window.open("https://www.desmos.com/", "_blank")} className="underlinetext">Desmos</span>. It enables users to incorporate visual representations of mathematical concepts, aiding better comprehension and learning.</p>
                    </div>
                    <br/>
                    <br/>
                </Modal.Body>
            </Modal>
            <Modal show={show43} onHide={handleClose43} aria-labelledby="contained-modal-title-vcenter" size="lg" centered>
                <Modal.Header closeButton>
                    <span className="redthis">Math Fill in the Blank</span>
                </Modal.Header>
                <Modal.Body>
                    <div className="disfullcenter">
                        <img src={Mathfillgif}  className="disfull1" alt="Math Fill in the Blank"/>
                        <br/>
                        <br/>
                        <p>The Math Slide feature allows you to upload images containing math, or generate graphics using <span onClick={()=>  window.open("https://www.desmos.com/", "_blank")} className="underlinetext">Desmos</span>. It allows students to input equations as their answers.</p>
                    </div>
                    <br/>
                    <br/>
                </Modal.Body>
            </Modal>
            <Modal show={show44} onHide={handleClose44} aria-labelledby="contained-modal-title-vcenter" size="lg" centered>
                <Modal.Header closeButton>
                    <span className="redthis">Math Single or Multi Select</span>
                </Modal.Header>
                <Modal.Body>
                    <div className="disfullcenter">
                        <img src={Mathmultigif}  className="disfull1" alt="Math Single or Multi Select"/>
                        <br/>
                        <br/>
                        <p>The Math Single or Multi-Select feature enables you to upload images containing math, create equations, include text, or generate <span onClick={()=>  window.open("https://www.desmos.com/", "_blank")} className="underlinetext">Desmos</span> graphics as answer options.</p>
                    </div>
                    <br/>
                    <br/>
                </Modal.Body>
            </Modal>
            <Modal show={show45} onHide={handleClose45} aria-labelledby="contained-modal-title-vcenter" size="lg" centered>
                <Modal.Header closeButton>
                    <span className="redthis">Math Sequencing</span>
                </Modal.Header>
                <Modal.Body>
                    <div className="disfullcenter">
                        <img src={Mathsequgif}  className="disfull1" alt="Math Sequencing"/>
                        <br/>
                        <br/>
                        <p>The Math Sequencing feature empowers you to upload math-based images, formulate equations as questions, and generate graphics using <span onClick={()=>  window.open("https://www.desmos.com/", "_blank")} className="underlinetext">Desmos</span> within your sequencing.</p>
                    </div>
                    <br/>
                    <br/>
                </Modal.Body>
            </Modal>
            <Modal show={show24} onHide={handleClose24} aria-labelledby="contained-modal-title-vcenter" size="lg" centered>
                <Modal.Header closeButton>
                    <span className="redthis">Word Cloud</span>
                </Modal.Header>
                <Modal.Body>
                    <div className="disfullcenter">
                        <img src={Wordcloudoverview}  className="disfull1"/>
                        <br/>
                        <br/>
                        <p>Word Cloud is an excellent icebreaker activity to kick off a meeting, workshop, or any gathering where participants are encouraged to engage and interact. Limit student responses to 25 characters.</p>
                    </div>
                    <br/>
                    <br/>
                </Modal.Body>
            </Modal>
            <Foot />
        </>
            :""
    );
}
export default Ceditroom;

